import type { IconProps } from './../../models/icon';

export function QuestionIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
  ...props
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M12 23.1429C18.1542 23.1429 23.1429 18.1542 23.1429 12C23.1429 5.84601 18.1542 0.857178 12 0.857178C5.84601 0.857178 0.857178 5.84601 0.857178 12C0.857178 18.1542 5.84601 23.1429 12 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 23.1429C18.1541 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.84601 18.1541 0.857178 12 0.857178C5.84601 0.857178 0.857178 5.84601 0.857178 12C0.857178 18.1541 5.84601 23.1429 12 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M9 8.9995C9 8.40615 9.17611 7.82614 9.50606 7.33279C9.83599 6.83945 10.305 6.45494 10.8536 6.22788C11.4023 6.00081 12.0061 5.94141 12.5885 6.05715C13.171 6.17292 13.706 6.45864 14.126 6.87819C14.5459 7.29775 14.8319 7.8323 14.9478 8.41423C15.0636 8.99618 15.0042 9.59937 14.7769 10.1475C14.5496 10.6957 14.1647 11.1643 13.6709 11.4939C13.1772 11.8235 12.5966 11.9995 12.0027 11.9995V13.9995"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.0048 18.0007C11.7285 18.0007 11.5044 17.7766 11.5044 17.5003C11.5044 17.2237 11.7285 16.9998 12.0048 16.9998"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.0051 18.0007C12.2815 18.0007 12.5056 17.7766 12.5056 17.5003C12.5056 17.2237 12.2815 16.9998 12.0051 16.9998"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}
